import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../i18n';
import {OverlayTrigger, Tooltip as BsTooltip} from 'react-bootstrap';

let tooltipId = 1;

export default function Tooltip(props) {
  const {placement, message, children, trigger, delay, ...rest} = props;

  return (
    <OverlayTrigger
      placement={placement}
      trigger={trigger}
      delay={delay}
      container={document.body}
      popperConfig={{
        modifiers: [
          {
            name: 'preventOverflow',
            enabled: false,
          },
        ],
      }}
      overlay={
        <BsTooltip id={`tooltip-${tooltipId++}`} {...rest}>
          {typeof message === 'string' ? <I18n t={message} /> : message}
        </BsTooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
}

Tooltip.defaultProps = {
  trigger: ['hover', ''], // The empty string here is to avoid https://github.com/react-bootstrap/react-bootstrap/issues/1300
  placement: 'top',
};

Tooltip.propTypes = {
  /** The element to place a tooltip on. */
  children: PropTypes.node.isRequired,
  /** What triggers the display of the tooltip. */
  trigger: PropTypes.oneOfType([PropTypes.oneOf(['hover', 'click', 'focus']), PropTypes.array]),
  /** Tooltip contents. When string is passed, it will be used as an i18n key for translation. */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** Tooltip placement relative to the target element. */
  placement: PropTypes.oneOf([
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start',
  ]),
  /** Milliseconds delay before showing the tooltip. */
  delay: PropTypes.number,
};
